/* iter-53o — Extracted from EditorPanel.jsx. The two tone-preset button
 * variants (compact toolbar + large end-of-chapter row) are pure
 * presentational components — they don't own any state and only depend on
 * props. Moving them out keeps EditorPanel.jsx focused on editor
 * orchestration and generation flow.
 */
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { fmtTokens } from '@/lib/tokenEstimate';

export function ToneButton({ label, Icon, kind, busy, onClick, disabled, enough, cost, testid }) {
  const isBusy = busy === kind;
  const otherBusy = busy && busy !== kind;
  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={Boolean(disabled) || isBusy || otherBusy}
      onClick={onClick}
      title={
        disabled
          ? 'Tone shift unavailable — sign in / upgrade to use AI tools.'
          : `Rewrite the last passage with a ${label.toLowerCase()} tone · est. ~${fmtTokens(cost)} tokens`
      }
      data-testid={testid}
      data-token-enough={enough ? '1' : '0'}
      className={`h-6 gap-1 px-1.5 text-[13px] disabled:opacity-50 disabled:cursor-not-allowed ${enough ? '' : 'text-amber-300'}`}
    >
      {isBusy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icon className="h-3.5 w-3.5" />}
      {label}
    </Button>
  );
}

// iter-53n — Larger end-of-chapter variant of the tone preset trio.
export function InlineToneButton({ label, Icon, kind, busy, onClick, disabled, enough, cost, testid }) {
  const isBusy = busy === kind;
  const otherBusy = busy && busy !== kind;
  return (
    <Button
      variant="outline"
      size="sm"
      disabled={Boolean(disabled) || isBusy || otherBusy}
      onClick={onClick}
      title={`Rewrite the last passage in a ${label.toLowerCase()} tone · ~${fmtTokens(cost)} tokens`}
      data-testid={testid}
      data-token-enough={enough ? '1' : '0'}
      className={`h-8 gap-1.5 rounded-full border-panel-border px-3 text-[13.5px] hover:bg-secondary ${enough ? '' : 'text-amber-300 border-amber-400/40'}`}
    >
      {isBusy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icon className="h-3.5 w-3.5" />}
      {label}
    </Button>
  );
}
